import type { CategoryTile, MenuItem, Service } from "../types";

export const menuItems: MenuItem[] = [
  {
    id: "eggs-benedict",
    name: "Eggs Benedict",
    subtitle: "with Smoked Salmon",
    description: "Brunch eggs with smoked salmon, herbs, and a glossy hollandaise.",
    category: "brunch",
    priceCents: 2200,
    image: "/assets/site/eggs-benedict.jpg",
    tags: ["brunch", "featured"],
    active: true,
    featured: true,
    sortOrder: 10
  },
  {
    id: "pan-seared-salmon",
    name: "Pan-Seared Salmon",
    subtitle: "with Lemon Herb Butter",
    description: "Crispy salmon with greens, charred lemon, and lemon herb butter.",
    category: "mains",
    priceCents: 3400,
    image: "/assets/site/salmon-main.jpg",
    tags: ["mains", "seafood"],
    active: true,
    featured: true,
    sortOrder: 20
  },
  {
    id: "beef-wellington",
    name: "Beef Wellington",
    subtitle: "with Red Wine Jus",
    description: "Golden pastry, tender beef, herbs, and red wine jus.",
    category: "mains",
    priceCents: 5200,
    image: "/assets/site/beef-wellington.jpg",
    tags: ["mains", "private chef"],
    active: true,
    featured: true,
    sortOrder: 30
  },
  {
    id: "nigerian-meat-pie",
    name: "Nigerian Meat Pie",
    subtitle: "Flaky, Spiced & Hearty",
    description: "Handmade pastry filled with spiced beef and vegetables.",
    category: "snacks",
    priceCents: 1400,
    image: "/assets/site/nigerian-meat-pie.jpg",
    tags: ["snacks", "nigerian classics"],
    active: true,
    featured: true,
    sortOrder: 40
  },
  {
    id: "warm-plum-tart",
    name: "Warm Plum Tart",
    subtitle: "with Vanilla Cream",
    description: "Ruby plum tart with golden pastry and vanilla cream.",
    category: "dessert",
    priceCents: 1800,
    image: "/assets/site/plum-tart.jpg",
    tags: ["dessert", "pastry"],
    active: true,
    featured: true,
    sortOrder: 50
  },
  {
    id: "jollof-rice",
    name: "Jollof Rice",
    subtitle: "with Grilled Chicken",
    description: "Smoky party jollof with grilled chicken and plantain.",
    category: "dinner plates",
    priceCents: 2800,
    image: "/assets/site/jollof-rice.jpg",
    tags: ["dinner", "nigerian classics"],
    active: true,
    featured: false,
    sortOrder: 60
  },
  {
    id: "garlic-prawns",
    name: "Garlic Butter Prawns",
    subtitle: "with Herb Rice",
    description: "Prawns in garlic butter with herb rice and lemon.",
    category: "dinner plates",
    priceCents: 3200,
    image: "/assets/site/garlic-prawns.jpg",
    tags: ["dinner", "seafood"],
    active: true,
    featured: false,
    sortOrder: 70
  },
  {
    id: "lamb-chops",
    name: "Lamb Chops",
    subtitle: "with Mint Chimichurri",
    description: "Seared lamb chops with mint chimichurri and vegetables.",
    category: "dinner plates",
    priceCents: 4600,
    image: "/assets/site/lamb-chops.jpg",
    tags: ["dinner", "private chef"],
    active: true,
    featured: false,
    sortOrder: 80
  },
  {
    id: "tuscan-chicken",
    name: "Creamy Tuscan Chicken",
    subtitle: "with Sun-Dried Tomatoes",
    description: "Chicken in creamy sauce with spinach and sun-dried tomatoes.",
    category: "dinner plates",
    priceCents: 3000,
    image: "/assets/site/tuscan-chicken.jpg",
    tags: ["dinner", "comfort"],
    active: true,
    featured: false,
    sortOrder: 90
  }
];

export const services: Service[] = [
  {
    id: "private-dining",
    name: "Private Chef Dinner",
    description: "A tailored chef-led dinner in your home, from planning to final plating.",
    priceCents: 125000,
    depositCents: 30000,
    image: "/assets/site/private-chef-plating.jpg",
    active: true,
    sortOrder: 10
  },
  {
    id: "brunch-table",
    name: "Brunch Table",
    description: "Weekend brunch favorites, pastries, cocktails, and a warm table.",
    priceCents: 85000,
    depositCents: 20000,
    image: "/assets/site/brunch-pancakes.jpg",
    active: true,
    sortOrder: 20
  },
  {
    id: "cocktail-night",
    name: "Cocktail Night",
    description: "A curated cocktail and small-bites experience for celebrations.",
    priceCents: 75000,
    depositCents: 15000,
    image: "/assets/site/cocktail.jpg",
    active: true,
    sortOrder: 30
  }
];

export const categoryTiles: CategoryTile[] = [
  {
    id: "brunch",
    title: "Brunch",
    body: "Weekend favourites made beautifully.",
    image: "/assets/site/brunch-pancakes.jpg",
    href: "/menus?category=brunch"
  },
  {
    id: "cocktails",
    title: "Cocktails",
    body: "Crafted drinks for any occasion.",
    image: "/assets/site/cocktail.jpg",
    href: "/private-chef#book"
  },
  {
    id: "pastry",
    title: "Pastry",
    body: "Bakes, tarts, and sweet little moments.",
    image: "/assets/site/pastry-tart.jpg",
    href: "/menus?search=pastry"
  },
  {
    id: "private-chef",
    title: "Private Chef",
    body: "Personalized dining in your home.",
    image: "/assets/site/private-chef-plating.jpg",
    href: "/private-chef"
  }
];
